"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadGatewayError = void 0;
const BaseError_1 = require("./BaseError");
/** BadGatewayError reports an invalid response from an upstream service. */
class BadGatewayError extends BaseError_1.BaseError {
    constructor(description = "Bad Gateway") {
        super("BadGatewayError", 502, description, true);
    }
}
exports.BadGatewayError = BadGatewayError;
